import {
  DIRECTION_LEFT,
  DIRECTION_DOWN,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import { BodyPlacement } from "./BodyPlacement";
import { TILES } from "../helpers/tiles";
import CharacterBody from "../components/object-graphics/CharacterBody";

const HORIZONTAL = "HORIZONTAL";
const VERTICAL = "VERTICAL";
const FLYING_ENEMY_MOVE_SPEED = 10;

export class FlyingEnemyPlacement extends BodyPlacement {
  constructor(properties, level) {
    super(properties, level);
    this.axis =
      this.facingDirection === DIRECTION_LEFT ||
      this.facingDirection === DIRECTION_RIGHT
        ? HORIZONTAL
        : VERTICAL;
    this.waitFramesBeforeAIMove = FLYING_ENEMY_MOVE_SPEED;
    this.framesUntilAiMove = this.waitFramesBeforeAIMove;
    this.isImmuneToIce = true;
    this.isImmuneToConveyor = true;
    this.isImmuneToTeleport = true;
    this.isImmuneToWallSwitch = true;
    this.enemyTickCheckForHero = true;
  }

  _handleAIMove() {
    if (this._nextSpaceIsFree(this.movingPixelDirection)) {
      this._move(this.movingPixelDirection);
    } else {
      //Flip direction
      this._switchDirection();
    }
  }

  _switchDirection() {
    if (this.axis === HORIZONTAL) {
      if (this.movingPixelDirection === DIRECTION_LEFT) {
        this.movingPixelDirection = DIRECTION_RIGHT;
        this.level.updateLivePlacement(this, {
          facingDirection: DIRECTION_RIGHT,
        }); // visual sprite change, needs to go through `emit`
      } else {
        this.movingPixelDirection = DIRECTION_LEFT;
        this.level.updateLivePlacement(this, {
          facingDirection: DIRECTION_LEFT,
        }); // visual sprite change, needs to go through `emit`
      }
    }
    if (this.axis === VERTICAL) {
      if (this.movingPixelDirection === DIRECTION_UP) {
        this.movingPixelDirection = DIRECTION_DOWN;
      } else {
        this.movingPixelDirection = DIRECTION_UP;
      }
    }
  }

  damagesBodyOnCollide(forBody) {
    return forBody.type === PLACEMENT_TYPE_HERO;
  }

  handleEnemyCollideWithHero() {
    this.level.setDeathType(this.type);
  }

  renderComponent() {
    const frameCoord =
      this.facingDirection === DIRECTION_RIGHT
        ? TILES.ENEMY_FLYING_RIGHT
        : TILES.ENEMY_FLYING_LEFT;
    return <CharacterBody bodyFrameCoord={frameCoord} />;
  }
}
